import { getLang, setCommonParam, setLang } from "@/plugins/env"

export default function ({ $cookies, store, route }) {
  const { storeId } = route.query
  if (process.client) {
    const lang = getLang({ $cookies, route })
    setLang({ store, $cookies, lang })
  }
  setCommonParam({ store, $cookies })
  // 检测url携带门店id，则更新cookie
}
